import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";

interface NumberedCardProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  number: string;
  styles?: Record<string, StyleValue>;
}

export const NumberedCard = forwardRef<HTMLDivElement, NumberedCardProps>(
  ({ number, content, styles = {}, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles });

    return (
      <div
        ref={ref}
        className={classNames(
          "wb-flex wb-flex-col wb-items-center wb-gap-4 wb-p-4 wb-text-center md:wb-gap-6 md:wb-px-6 md:wb-py-0",
          className,
        )}
        style={inlineStyles}
        {...rest}
      >
        <div className="wb-bg-button-primary wb-flex wb-h-12 wb-w-12 wb-items-center wb-justify-center wb-rounded-full">
          {number}
        </div>
        <div className="wb-flex wb-flex-col wb-gap-2 md:wb-gap-4">
          {content}
        </div>
      </div>
    );
  },
);
NumberedCard.displayName = "NumberedCard";
